import '@ohear/ui/styles'
import { createRoot } from 'react-dom/client'
import { App } from './App'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('root element not found')

// No StrictMode: the LiveKit Room lifecycle (connect/publish/disconnect) is
// managed in an effect and double-invocation in dev causes spurious
// join/leave churn in the room. Revisit once the room hook is idempotent.
createRoot(rootEl).render(<App />)
